import fetchAPI from '../fetchAPI';

export const callUpdateBillingAccount = async (
  id: string,
  data: any
): Promise<iResponse<BillingAccount>> => {
  const response: iResponse<BillingAccount> = await fetchAPI({
    method: `PATCH`,
    route: `billing-accounts/${id}`,
    data
  });

  return response;
};

export default callUpdateBillingAccount;
